import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import '../../../assets/css/BloomLanding.css';
import Logo from "../../../assets/images/bloom.png";
// import bloom from '../../../assets/images/BloomHero.png'
import CartSlider from "../../CartSlider/CartSliderBar"; // Import cart slider
import { FaShoppingCart } from "react-icons/fa"; // Import cart icon
import { useCart } from "../../CartContext/CartContextComp"; // Import cart context

const BloomNavBar = () => {
  const navigate = useNavigate();
  const { cartItems } = useCart(); // Get cart items
  const [cartOpen, setCartOpen] = useState(false); // Control cart slider visibility

  const handleContactClick = (e) => {
    e.preventDefault(); // Prevent default anchor behavior

    navigate("/bloom");

    setTimeout(() => {
      const contactSection = document.getElementById("contact");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); // Small delay to ensure navigation happens first
  };
  return (
    <div>
      <nav className="bloom-navbar">
        <div className="bloom-logo">
          <Link to="/bloom">
            <img src={Logo} alt="Bloom Logo" className="bloom-logo-image" />
          </Link>
        </div>
        <div className="bloom-nav-links">
          <Link to="/">Home</Link>
          {/* <Link to="/">Collection</Link> */}
          <Link onClick={handleContactClick}>Contact Us</Link>
          {/* Cart Icon */}
          <div className="cart-container" onClick={() => setCartOpen(true)}>
            <FaShoppingCart className="cart-icon" />
            {cartItems.length > 0 && <span className="cart-count">{cartItems.length}</span>}
          </div>
        </div>
        {/* Cart Slider */}
        {cartOpen && (
          <CartSlider cartItems={cartItems} onClose={() => setCartOpen(false)} />
        )}
      </nav>
    </div>
  )
}

export default BloomNavBar